module.exports = "./img/70cbb8573304b02005e7a28879a09bb5.jpg";